import { useState } from 'react';
import axios from 'axios';
import { VacationRequestType } from '../../../../../tabs/hooks/useSummaryInfo';
import { VacationTypes } from 'src/tabs/constants/Timeoff.constants';

export const useCancelRequest = (vacationRequestId?: string) => {
  const [cancelRequestStatus, setCancelRequestStatus] = useState<string>();
  const [loadingCancelRequestStatus, setLoadingCancelRequestStatus] =
    useState<boolean>();

  const cancelRequest = async (
    getSummary: (
      bonusDays?: number,
      paidDays?: number,
      requestType?: VacationRequestType
    ) => Promise<void>,
    numberOfDays?: number,
    vacationType?: string
  ) => {
    try {
      setLoadingCancelRequestStatus(true);
      const { data } = await axios.patch(
        `api/vacation-requests/my/${vacationRequestId}/cancelVacationRequest`
      );
      data && setCancelRequestStatus(data);
      if (vacationType === VacationTypes.PAID_VACATION_BONUS_DAYS) {
        getSummary(numberOfDays, 0, VacationRequestType.Cancel);
      } else if (vacationType === VacationTypes.PAID_VACATION) {
        getSummary(0, numberOfDays, VacationRequestType.Cancel);
      } else {
        await getSummary();
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingCancelRequestStatus(false);
    }
  };

  return {
    cancelRequestStatus,
    cancelRequest,
    loadingCancelRequestStatus,
  };
};
